import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ServerManagement.css';

const ServerManagementHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>ניהול שרתים מנוהל - AWS, Azure, GCP ועוד | Epicfinal</title>
                <meta name="title" content="ניהול שרתים מנוהל - AWS, Azure, GCP ועוד | Epicfinal" />
                <meta name="description" content="ניהול שרתים מלא ב-$139.90 לחודש. ניטור 24/7, עדכוני אבטחה, אופטימיזציית ביצועים ותחזוקה שוטפת. עובד עם AWS, Azure, Google Cloud או כל ספק אחסון אחר." />
                <meta name="keywords" content="ניהול שרתים, שרת מנוהל, ניהול שרתי ענן, ניהול AWS, ניהול Azure, ניהול Google Cloud, ניטור שרתים, אבטחת שרתים, תחזוקת שרתים, ניהול שרתים חיצוניים, ניהול VPS, ניהול שרת ייעודי" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/server-management" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/server-management" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/server-management" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/server-management" />
                <meta property="og:title" content="ניהול שרתים מנוהל | Epicfinal" />
                <meta property="og:description" content="ניהול שרתים מלא ב-$139.90 לחודש. ניטור 24/7, עדכוני אבטחה ותחזוקה לכל פלטפורמת ענן." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal ניהול שרתים - תמיכה בריבוי עננים" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/server-management" />
                <meta name="twitter:title" content="ניהול שרתים מנוהל | Epicfinal" />
                <meta name="twitter:description" content="ניהול שרתים מלא ב-$139.90 לחודש. עובד עם AWS, Azure, GCP או כל ספק אחר." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "ניהול ענן ציבורי ושרתים חיצוניים",
                        "description": "ניהול שרתים מלא כולל ניטור, עדכוני אבטחה, אופטימיזציית ביצועים ותחזוקה שוטפת לכל ספק ענן או אחסון",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "ניהול שרתים",
                        "areaServed": "Worldwide",
                        "offers": {"@type": "Offer", "price": "139.90", "priceCurrency": "USD", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock"},
                        "url": "https://epicfinal.com/he/server-management"
                    }
                `}</script>
            </Helmet>

            <div className="server-mgmt-page">
                {/* Hero Section */}
                <section className="server-hero">
                    <div className="container">
                        <div className="server-hero-content">
                            <div className="server-icon-badge">
                                <i className="las la-server"></i>
                            </div>
                            <h1 className="server-hero-title">
                                ניהול ענן ציבורי / שרתים חיצוניים
                            </h1>
                            <p className="server-hero-subtitle">
                                ניהול מלא עבור הענן או השרת החיצוני שלכם
                            </p>
                            <p className="server-hero-description">
                                אנו מספקים ניהול מלא לשרת בודד המתארח בפלטפורמת ענן ציבורי (כגון AWS) או אצל כל ספק אחסון אחר – כולל ניטור, עדכוני אבטחה, אופטימיזציית ביצועים ותחזוקה שוטפת, כדי שהסביבה שלכם תישאר יציבה ואמינה.
                            </p>
                            <div className="server-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-external-server&language=hebrew&currency=2"
                                    className="btn-server btn-primary" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו - ₪499.90 לחודש
                                </a>
                                <Link to="/contact1" className="btn-server btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="server-features">
                    <div className="container">
                        <div className="server-section-header">
                            <h2>ניהול שרתים מקיף</h2>
                            <p>כל מה שאתם צריכים לשרת יציב ומאובטח</p>
                        </div>
                        <div className="server-features-grid">
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-chart-line"></i>
                                </div>
                                <h3>ניטור רציף</h3>
                                <p>ניטור מתקדם עם סוכן (Agent) חכם העוקב אחר מעבד, זיכרון, דיסק וביצועי רשת.</p>
                            </div>
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>עדכוני אבטחה</h3>
                                <p>עדכוני מערכת וטלאי אבטחה (Patches) קבועים לשמירה על השרת שלכם מוגן מפני איומים.</p>
                            </div>
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-cogs"></i>
                                </div>
                                <h3>אופטימיזציית ביצועים</h3>
                                <p>כיוונון מתמשך להבטחת ביצועי שרת מיטביים וניצול יעיל של המשאבים.</p>
                            </div>
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-tools"></i>
                                </div>
                                <h3>תחזוקה שוטפת</h3>
                                <p>משימות תחזוקה קבועות, עדכונים ופתרון בעיות פרואקטיבי.</p>
                            </div>
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-headset"></i>
                                </div>
                                <h3>תמיכת מומחים</h3>
                                <p>גישה ישירה לצוות מנהלי השרתים המנוסה שלנו.</p>
                            </div>
                            <div className="server-feature-card">
                                <div className="server-feature-icon">
                                    <i className="las la-cloud"></i>
                                </div>
                                <h3>תמיכה בריבוי עננים</h3>
                                <p>עובד עם AWS, Azure, Google Cloud או כל ספק אחסון אחר.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* What's Included Section */}
                <section className="server-included">
                    <div className="container">
                        <div className="server-section-header">
                            <h2>מה כלול בשירות</h2>
                            <p>שירותי ניהול שרתים מקיפים</p>
                        </div>
                        <div className="server-included-grid">
                            <div className="server-included-column">
                                <h3><i className="las la-check-circle"></i> ניטור והתראות</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> התקנת סוכן ניטור חכם</li>
                                    <li><i className="las la-angle-left"></i> ניטור משאבים בזמן אמת</li>
                                    <li><i className="las la-angle-left"></i> התראות מיידיות על תקלות</li>
                                    <li><i className="las la-angle-left"></i> מעקב אחר מדדי ביצועים</li>
                                </ul>
                            </div>
                            <div className="server-included-column">
                                <h3><i className="las la-check-circle"></i> אבטחה ועדכונים</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> רכיב אבטחה מובנה</li>
                                    <li><i className="las la-angle-left"></i> עדכוני מערכת קבועים</li>
                                    <li><i className="las la-angle-left"></i> טלאי אבטחה</li>
                                    <li><i className="las la-angle-left"></i> סריקת פגיעויות</li>
                                </ul>
                            </div>
                            <div className="server-included-column">
                                <h3><i className="las la-check-circle"></i> תחזוקה ותמיכה</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> תחזוקה שוטפת</li>
                                    <li><i className="las la-angle-left"></i> אופטימיזציית ביצועים</li>
                                    <li><i className="las la-angle-left"></i> פתרון תקלות</li>
                                    <li><i className="las la-angle-left"></i> תמיכה טכנית מומחית</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="server-pricing">
                    <div className="container">
                        <div className="server-pricing-card">
                            <div className="server-pricing-header">
                                <h2>שירות ניהול שרתים</h2>
                                <p>ניהול מלא לשרת אחד</p>
                            </div>
                            <div className="server-pricing-body">
                                <div className="server-pricing-amount">
                                    <span className="server-price">$139.90</span>
                                    <span className="server-period">חודשי / USD</span>
                                </div>
                                <ul className="server-pricing-features">
                                    <li><i className="las la-check"></i> שרת אחד (וירטואלי או ייעודי)</li>
                                    <li><i className="las la-check"></i> סוכן ניטור חכם</li>
                                    <li><i className="las la-check"></i> ניטור רציף 24/7</li>
                                    <li><i className="las la-check"></i> עדכוני מערכת קבועים</li>
                                    <li><i className="las la-check"></i> טלאי אבטחה והקשחה</li>
                                    <li><i className="las la-check"></i> אופטימיזציית ביצועים</li>
                                    <li><i className="las la-check"></i> תחזוקה שוטפת</li>
                                    <li><i className="las la-check"></i> תמיכה טכנית מקצועית</li>
                                </ul>
                                <div className="server-pricing-note">
                                    <i className="las la-info-circle"></i>
                                    <p><strong>הערה:</strong> השירות מכסה שרת אחד בלבד. עובד עם כל ספק ענן או פלטפורמת אחסון.</p>
                                </div>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-external-server&language=hebrew&currency=2"
                                    className="server-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="server-cta">
                    <div className="container">
                        <div className="server-cta-content">
                            <h2>מוכנים לפשט את ניהול השרתים שלכם?</h2>
                            <p>תנו למומחים שלנו לטפל בשרת שלכם, בזמן שאתם מתמקדים בעסק שלכם.</p>
                            <div className="server-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-external-server&language=hebrew&currency=2"
                                    className="btn-server btn-light" target="_blank" rel="noopener noreferrer">
                                    הזמינו שירות
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-server btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ServerManagementHe;
